export default "__VITE_ASSET__DQo3Ow1R__"